import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { focusElement } from 'platform/utilities/ui';

import SearchResult from './SearchResult';

const ResultsList = () => {
  const searchResultTitle = useRef();

  const searchResults = useSelector(state => state.searchResult.searchResults);
  const inProgress = useSelector(state => state.searchQuery.inProgress);

  useEffect(
    () => {
      focusElement(searchResultTitle.current);
    },
    [searchResults, inProgress],
  );

  return (
    <div className="representative-results-list">
      {!!searchResults.length && (
        <>
          <hr />
          {searchResults.map((result, index) => (
            <div key={index} className="vads-u-margin-bottom--4">
              <SearchResult index={index} representative={result} />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default ResultsList;
